var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sliderElBlog"},_vm._l((_vm.localArticles),function(article){return _c('blog-card',{key:article.id,attrs:{"article":article,"image-height":343}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }